{
	"title": "Komentarze",
	"statuses": {
		"inValidation": "W trakcie walidacji",
		"rejected": "Odrzucone",
		"assured": "Potwierdzone",
		"flagged": "Oznaczone",
		"resolved": "Rozwiązane"
	}
}
